import { Typography, DataTable, Loading, Button, Anchor } from '@ui/components';
import { Link } from 'react-router-dom';
import { Routes } from '@shared/enums';
import { cn } from '@ui/utils';
import { FC } from 'react';

import {
  useCostCenterTransactionsHistory,
  TransactionsHistoryFilters,
} from './use-cost-center-transactions-history';

export const CostCenterTransactionsHistory: FC<{
  filters?: TransactionsHistoryFilters;
  className?: string;
}> = ({ className, filters }) => {
  const { table, isLoading, t, columnsLength, isTableConfigLoading } =
    useCostCenterTransactionsHistory(filters);

  return (
    <div className={cn('flex flex-col bg-table-background rounded-lg overflow-hidden', className)}>
      <div className="flex items-center px-4 py-3">
        <Typography variant="labelMediumBook">
          {t('COST_CENTER.TRANSACTIONS_HISTORY.TITLE')}
        </Typography>
      </div>
      <div className="flex-1 overflow-hidden">
        <Loading isLoading={isTableConfigLoading} className="h-full">
          <DataTable
            noResultsComponent={
              <div className="flex items-center justify-center h-full">
                <Typography variant="labelMediumMedium" className="w-50">
                  {t('COST_CENTER.TRANSACTIONS_HISTORY.EMPTY')}
                </Typography>
              </div>
            }
            className="h-full overflow-auto w-full"
            columnsLength={columnsLength}
            isLoading={isLoading}
            table={table}
          />
        </Loading>
      </div>
      <Anchor asChild>
        <Link
          to={{
            pathname: `../../${Routes.FILES_REPORTS}/${Routes.TRANSACTION_HISTORY}`,
            search: `dateFrom=${filters?.dateFrom}&dateTo=${filters?.dateTo}`,
          }}
        >
          <Button disabled={isLoading} variant="link" wide>
            {t('COST_CENTER.TRANSACTIONS_HISTORY.VIEW_ALL')}
          </Button>
        </Link>
      </Anchor>
    </div>
  );
};
